import { Translation } from '../types';

export default  {
  // Aplicación
  appTitle: "OK Money - Simulador de Plan de Vida",
  
  // Navegación
  navigation: {
    home: "Inicio",
    lifePlan: "Plan de Vida",
    riskSimulation: "Simulación de Riesgo",
    contact: "Contacto",
    openMenu: "Abrir Menú",
    lifePlanDescription: "Cree un plan de vida para diseñar su futuro",
    riskSimulationDescription: "Ejecute una simulación de riesgo para evaluar los riesgos de inversión",
  },

  // Home
  home: {
    hero: {
      title: "Planificación de Vida Real a través de Simulación",
      subtitle: "Optimice su plan de vida con simulaciones que consideran la incertidumbre",
      download: "Descargar",
      docs: "Documentación"
    },
    features: {
      codeCompletion: {
        title: "Simulación en Tiempo Real",
        description: "Simule las fluctuaciones del mercado en tiempo real y proponga planes financieros óptimos"
      },
      codebase: {
        title: "Análisis con IA",
        description: "Analice su cartera de inversiones utilizando datos históricos e IA, y sugiera mejoras"
      },
      naturalLanguage: {
        title: "Inversiones que Enriquecen su Vida",
        description: "Aumente sus activos a través de inversiones mientras asegura los fondos necesarios para la vida diaria"
      }
    },
  },

  // Información de la empresa y términos de servicio
  company: {
    title: "Información de la Empresa",
    basicInfo: "Información Básica",
    operatorName: "Nombre de la Empresa Operadora",
    startDate: "Fecha de Fundación",
    startDateValue: "28 de abril de 2025",
    location: "Ubicación",
    locationValue: "Yokohama, Prefectura de Kanagawa",
    contact: "Contacto",
    contactForm: "Formulario de Contacto",
    businessDescription: "Descripción del Negocio",
    businessDescriptionContent: "Provisión de servicios de simulación de planes de vida",
    developerProfile: "Perfil del Desarrollador",
    developerProfileContent: "Desarrollado por un ingeniero de SIer. Con el nacimiento de mi hijo, aspiro a crear un servicio que contribuya a disfrutar plenamente tanto del presente como del futuro al planificar la vida.",
    privacyPolicy: "Política de Privacidad",
    privacyPolicyLink: "Ver política de privacidad completa",
    termsOfService: "Términos de Servicio",
    termsOfServiceContent: "Nuestra empresa considera la protección de la información personal de nuestros clientes como una prioridad máxima.",
    contentEnd: "Si tiene alguna pregunta, no dude en contactarnos."
  },
  terms: {
    title: "Términos de Servicio",
    termsOfService: "Términos de Servicio",
    privacyPolicy: "Política de Privacidad",
    article1: {
      title: "Artículo 1 (Aplicación)",
      content: "Estos términos establecen las condiciones de uso del servicio (en adelante, \"este servicio\") proporcionado por OKMoney (en adelante, \"nuestra empresa\")."
    },
    article2: {
      title: "Artículo 2 (Registro de Usuario)",
      content1: "1. Para utilizar este servicio, es necesario registrarse de acuerdo con los métodos establecidos por nuestra empresa, aceptando estos términos.",
      content2: "2. Nuestra empresa puede rechazar el registro si determina que el solicitante cumple con alguna de las siguientes condiciones:",
      listItem1: "Si el solicitante ha violado estos términos anteriormente",
      listItem2: "En otros casos que nuestra empresa considere inapropiado el registro"
    },
    article3: {
      title: "Artículo 3 (Prohibiciones)",
      content: "Los usuarios no deben realizar las siguientes acciones:",
      listItem1: "Acciones que violen las leyes o el orden público",
      listItem2: "Acciones relacionadas con actividades delictivas",
      listItem3: "Acciones que puedan interferir con la operación de nuestros servicios",
      listItem4: "Acciones que molesten a otros usuarios",
      listItem5: "Otras acciones que nuestra empresa considere inapropiadas"
    },
    article4: {
      title: "Artículo 4 (Parada o interrupción del servicio)",
      content: "Nuestra empresa puede detener o interrumpir la provisión total o parcial de este servicio si determina que existe alguna de las siguientes razones:",
      listItem1: "Si es necesario realizar la revisión o actualización del sistema informático de este servicio",
      listItem2: "Si ocurre un terremoto, rayo, incendio, apagón o desastre natural, y la provisión de este servicio resulta difícil",
      listItem3: "En otros casos que nuestra empresa determine que la provisión de este servicio resulta difícil"
    },
    article5: {
      title: "Artículo 5 (Exención de responsabilidad)",
      content: "Nuestra empresa no asume responsabilidad alguna entre los usuarios y otros usuarios o terceros entre sí, ni en relación con cualquier transacción, comunicación o disputa que surja entre ellos."
    },
    article6: {
      title: "Artículo 6 (Cambio del servicio)",
      content: "Nuestra empresa puede cambiar o detener la provisión de este servicio sin notificar al usuario y no asume responsabilidad alguna por las pérdidas que pueda sufrir el usuario como consecuencia de ello."
    },
    article7: {
      title: "Artículo 7 (Cambio de términos)",
      content: "Nuestra empresa puede cambiar estos términos en cualquier momento sin notificar al usuario."
    },
    article8: {
      title: "Artículo 8 (Notificación o Contacto)",
      content: "La notificación o contacto entre el usuario y nuestra empresa se realizará de acuerdo con el método establecido por nuestra empresa."
    },
    article9: {
      title: "Artículo 9 (Prohibición de Transferencia de Derechos y Obligaciones)",
      content: "El usuario no puede transferir o dar en garantía la posición en el contrato de uso o estos términos a terceros sin el previo consentimiento por escrito de nuestra empresa."
    },
    article10: {
      title: "Artículo 10 (Ley y Jurisdicción)",
      content1: "1. Para la interpretación de estos términos, se considerará la ley japonesa como la ley de referencia.",
      content2: "2. Si surge una disputa en relación con este servicio, se considerará que la empresa tiene jurisdicción exclusiva en la sede de su oficina principal."
    },
    privacy: {
      article1: {
        title: "1. Recopilación de Información Personal",
        content: "En nuestro sitio web, es posible que se recopilen la siguiente información personal:",
        listItem1: "Nombre",
        listItem2: "Dirección de correo electrónico",
        listItem3: "Dirección",
        listItem4: "Número de teléfono",
        listItem5: "Otras informaciones necesarias para la provisión de servicios"
      },
      article2: {
        title: "2. Uso de la Información Personal",
        content: "La información personal recopilada se utilizará para los siguientes propósitos:",
        listItem1: "Provisión y operación del servicio",
        listItem2: "Respuesta a consultas",
        listItem3: "Mejora y desarrollo del servicio",
        listItem4: "Notificación de información importante"
      },
      article3: {
        title: "3. Gestión de la Información Personal",
        content: "En nuestro sitio web, se implementan medidas de seguridad adecuadas para prevenir la filtración, pérdida o daño de la información personal."
      },
      article4: {
        title: "4. Provisión de Información Personal a Terceros",
        content: "En nuestro sitio web, no se proporcionará información personal a terceros, excepto en los siguientes casos:",
        listItem1: "Si hay consentimiento del interesado",
        listItem2: "Si es necesario de acuerdo con la ley",
        listItem3: "Si es necesario para proteger la vida, la salud o los bienes del interesado"
      },
      article5: {
        title: "5. Contacto",
        content: "Para consultas sobre la política de privacidad, comuníquese a través del formulario de contacto."
      },
      article6: {
        title: "6. Cambio de la Política de Privacidad",
        content: "Nuestro sitio web puede cambiar la política de privacidad cuando sea necesario. Se informará en nuestro sitio web cuando se realice el cambio."
      }
    }
  },

  // Común
  common: {
    years: "Años",
    perYear: "/Año",
    perMonth: "/Mes",
    age: "Edad",
    yes: "Sí",
    no: "No",
    none: "Ninguno",
    notEntered: "No ingresado",
    add: "Añadir",
    delete: "Eliminar",
    save: "Guardar",
    cancel: "Cancelar",
    reset: "Restablecer",
    month: "Mes",
    select: "Seleccionar",
    clearSelection: "Borrar selección",
    dateTime: "Fecha y hora",
    actions: "Acciones",
    currencies: {
      jpy: "Yen japonés",
      usd: "Dólar estadounidense",
      eur: "Euro",
      gbp: "Libra esterlina",
      aud: "Dólar australiano",
      cad: "Dólar canadiense",
      chf: "Franco suizo",
      cny: "Yuan chino",
      hkd: "Dólar de Hong Kong",
      sgd: "Dólar de Singapur"
    },
    currency: "Moneda",
    currencyHelp: "Seleccione la moneda. La simulación se realizará en la moneda seleccionada.",
    statistics: {
      title: "Estadísticas",
      mean: "Media",
      median: "Mediana",
      min: "Mínimo",
      max: "Máximo",
      mode: "Moda",
      totalInvestment: "Inversión total",
      assetDistribution: "Distribución de activos",
      targetAchieveRate: "Tasa de logro del objetivo",
      probability: "Probabilidad",
      medianFinalAsset: "Activo final mediano",
      finalAsset: "Activo final",
    },
  },

  // Simulación de Riesgo
  riskSimulation: {
    title: "Simulación de Riesgo",
    simulationSettings: "Configuración de la Simulación",
    initialInvestment: "Inversión Inicial",
    investmentAmount: "Monto de Inversión",
    investmentPeriod: "Período de Inversión",
    annualReturnRate: "Tasa de Retorno Anual",
    monthlyInvestment: "Inversión Mensual",
    volatility: "Volatilidad",
    targetAmount: "Monto Objetivo",
    runSimulation: "Ejecutar Simulación",
    running: "Ejecutando",
    simulationInstruction: "Por favor, ejecute primero la simulación.",
    noSimulationRun: "Simulación no ejecutada",
    simulationResults: "Resultados de la Simulación",
    currentResults: "Resultados Actuales",
    savedResults: "Resultados Guardados",
    compare: "Comparar",
    resultTitle: "Resultados de la Simulación de Riesgo",
    simulationConditions: "Condiciones de la Simulación",
    saveSimulationResult: "Guardar Resultados de la Simulación",
    saveSimulationDescription: "Por favor, ingrese un nombre para los resultados de la simulación.",
    simulationName: "Nombre de la Simulación",
    simulationNamePlaceholder: "Ingrese el nombre de los resultados de la simulación",
    saveSimulation: "Guardar Simulación",
    noSavedSimulations: "No hay simulaciones guardadas",
    noSavedSimulationsDescription: "No se encontraron simulaciones guardadas. Por favor, ejecute una simulación primero.",
    createNewSimulation: "Crear Nueva Simulación",
    selectSimulationsToCompare: "Seleccionar Simulaciones para Comparar",
    noSelectedSimulations: "No hay simulaciones seleccionadas",
    selectTwoOrMoreSimulations: "Por favor, seleccione dos o más simulaciones.",
    comparisonResults: "Resultados de la Comparación",
    finalAssetComparison: "Comparación de Activos Finales",
    finalAssetComparisonDescription: "Comparación de activos finales entre simulaciones",
    successRateComparison: "Comparación de Tasa de Éxito",
    successRateComparisonDescription: "Comparación de tasas de éxito entre simulaciones",
    simulationParameters: "Parámetros de la Simulación",
    simulationParametersDescription: "Comparación de parámetros de simulación",
    period: "Período",
    successRate: "Tasa de éxito",
    backToSimulation: "Volver a la simulación",
  },

  // Plan de Vida
  lifePlan: {
    title: "Creación de Plan de Vida",
    resultTitle: "Resultados de la Simulación del Plan de Vida",
    steps: {
      basicInfo: "Información Básica",
      incomeExpense: "Ingresos y Gastos",
      assetsLiabilities: "Activos y Pasivos",
      lifeGoals: "Eventos de Vida",
      simulationSettings: "Configuración de la Simulación",
      confirmation: "Confirmación",
    },
    navigation: {
      prev: "Anterior",
      next: "Siguiente",
      startSimulation: "Iniciar Simulación",
      confirmStart: "¿Desea iniciar la simulación?",
      confirmStartTitle: "Confirmar Inicio de Simulación",
      cancel: "Cancelar",
    },
    basicInfo: {
      title: "Información Básica",
      name: "Nombre",
      namePlaceholder: "Ingrese su nombre",
      age: "Edad",
      gender: {
        title: "Género",
        male: "Masculino",
        female: "Femenino",
        other: "Otro",
      },
      familyStructure: {
        title: "Estructura Familiar",
        hasSpouse: "Con Cónyuge",
        spouseAge: "Edad del Cónyuge",
        children: "Hijos",
        help: "Ingrese la estructura familiar",
        childrenHelp: "Ingrese la edad de los hijos",
        addChild: "Agregar Hijo",
        removeChild: "Eliminar Hijo",
        noChildren: "Sin hijos",
      },
      spouse: "Cónyuge",
      children: "Hijos"
    },
    incomeExpense: {
      title: "Ingresos y Gastos",
      income: {
        title: "Ingresos",
        annualIncome: "Ingreso Anual (Millones de Yen)",
        salaryIncreaseRate: "Tasa de Incremento Salarial (%)",
        annualBonus: "Bono Anual (Millones de Yen)",
      },
      expense: {
        title: "Gastos",
        help: "Ingrese el gasto mensual",
        housingCost: "Costo de Vivienda (Millones de Yen/Mes)",
        housingCostHelp: "Ingrese el monto del alquiler o préstamo mensual",
        utilities: "Costo de Servicios (Millones de Yen/Mes)",
        food: "Costo de Alimentación (Millones de Yen/Mes)",
        communication: "Costo de Comunicación (Millones de Yen/Mes)",
        transportation: "Costo de Transporte (Millones de Yen/Mes)",
        entertainment: "Costo de Entretenimiento (Millones de Yen/Mes)",
        investment: "Inversión (Millones de Yen/Mes)",
        stocks: "Inversión en Acciones (Millones de Yen/Mes)",
        bonds: "Inversión en Bonos (Millones de Yen/Mes)",
        mutualFunds: "Inversión en Fideicomisos (Millones de Yen/Mes)",
        insurance: "Costo de Seguro (Millones de Yen/Mes)",
        other: "Otro (Millones de Yen/Mes)"
      },
      annualIncome: "Ingreso Anual",
      salaryIncreaseRate: "Tasa de Incremento Salarial",
      annualBonus: "Bono Anual",
      housingCost: "Costo de Vivienda",
      utilities: "Costo de Servicios",
      food: "Costo de Alimentación",
      communication: "Costo de Comunicación",
      transportation: "Costo de Transporte",
      entertainment: "Costo de Entretenimiento",
      other: "Otro"
    },
    assetsLiabilities: {
      title: "Activos y Pasivos",
      assets: {
        title: "Activos",
        savings: "Ahorros",
        stocks: "Acciones",
        bonds: "Bonos",
        mutualFunds: "Fondos Mutuos",
        insurance: "Seguros",
        other: "Otros",
        amount: "Monto (10,000 €)",
        return: "Retorno Esperado (%)",
        volatility: "Volatilidad (%)",
        investmentAssets: "Activos de Inversión",
      },
      liabilities: {
        title: "Pasivos",
        housingLoan: "Préstamo Hipotecario",
        carLoan: "Préstamo de Auto",
        otherLoans: "Otros Préstamos",
        addLoan: "Añadir Préstamo",
        removeLoan: "Eliminar Préstamo",
        name: "Nombre del Préstamo",
        amount: "Monto del Préstamo (10,000 €)",
        period: "Plazo (años)",
        interestRate: "Tasa de Interés (%)",
        noLoans: "Sin Préstamos",
      },
      savings: "Ahorros",
      stocks: "Acciones",
      bonds: "Bonos",
      mutualFunds: "Fondos Mutuos",
      insurance: "Seguros",
      otherInvestments: "Otras Inversiones",
      housingLoanBalance: "Saldo del Préstamo Hipotecario",
      housingLoanPeriod: "Plazo del Préstamo",
      housingLoanInterest: "Tasa de Interés",
      noLoans: "Sin Préstamos",
      otherLoans: "Otros Préstamos"
    },
    lifeGoals: {
      title: "Eventos de Vida",
      housingPurchase: "Compra de Vivienda",
      educationFunds: "Fondos Educativos",
      child: "Hijo",
      otherGoals: "Otros Objetivos",
      retirementAge: "Edad de Retiro",
      retirementMonthlyExpense: "Gasto Mensual después de Retirarse",
      notPlanned: "No Planificado",
      housing: {
        title: "Compra de Vivienda",
        planned: "Planificado para Compra de Vivienda",
        year: "Año Planificado para Compra",
        amount: "Monto Planificado para Compra (Millones de Yen)",
        purchaseAmount: "Monto de Compra (Millones de Yen)",
        purchaseYear: "Año de Compra",
      },
      education: {
        title: "Plan de fondos educativos",
        subtitle: "Planificación de fondos educativos",
        add: "Añadir fondo educativo",
        remove: "Eliminar fondo educativo",
        name: "Nombre del fondo educativo",
        namePlaceholder: "Ingrese el nombre del fondo educativo",
        childAge: "Edad del hijo",
        age: "Edad requerida",
        amount: "Monto requerido",
        requiredAmount: "Monto requerido",
        noData: "No se han añadido fondos educativos",
      },
      other: {
        title: "Otros Objetivos",
        subtitle: "Otros Eventos de Vida",
        add: "Agregar Objetivo",
        remove: "Eliminar Objetivo",
        name: "Nombre del Objetivo",
        year: "Año del Objetivo",
        amount: "Monto Requerido (Millones de Yen)",
        noData: "No hay objetivos",
        namePlaceholder: "Ingrese el nombre de otro objetivo",
        plannedAge: "Edad Planificada",
        requiredAmount: "Monto Requerido"
      },
      retirement: {
        title: "Plan de Retiro",
        age: "Edad Planificada de Retiro",
        monthlyExpense: "Gasto Mensual después de Retirarse (Millones de Yen)",
      },
    },
    simulationSettings: {
      title: "Configuración de la Simulación",
      inflationRate: "Tasa de Inflación (%)",
      investmentReturn: "Retorno de Inversión (%)",
      simulationPeriod: "Período de Simulación (Años)",
      currency: "Moneda",
      currencyHelp: "Seleccione la moneda. La simulación se realizará en la moneda seleccionada.",
      inflationRateHelp: "Simulación considerando la tasa de inflación futura."
    },
    runningSimulation: "Simulación en Ejecución",
    result: {
      title: "Resultados de la Simulación del Plan de Vida",
      settings: "Configuración del Plan de Vida",
      planSettings: "Configuración del Plan",
      actions: {
        print: "Imprimir",
        downloadCSV: "Descargar CSV",
        modifyConditions: "Modificar Condiciones",
        backToInput: "Regresar a la Pantalla de Entrada",
      },
      tabs: {
        charts: "Gráficos",
        details: "Detalles",
        analysis: "Análisis y Recomendación",
      },
      charts: {
        assetIncomeExpense: "Cambio de Activos y Gastos",
        agePoint: "{age} Año",
        spouse: "Cónyuge: {age} Año",
        children: "Hijo",
        age: "{age} Año",
        assets: "Activos",
        liabilities: "Pasivos",
        netWorth: "Patrimonio Neto",
        amount: "Monto (Millones de Yen)",
        noData: "No hay datos",
        assetTrend: "Cambio de Activos",
        incomeExpenseTrend: "Cambio de Gastos",
        income: "Ingresos",
        expense: "Gastos",
        savings: "Ahorro",
      },
      details: {
        yearlyData: "Detalles de Datos Anuales",
      },
      analysis: {
        risk: "Análisis de Riesgo",
        recommendations: "Recomendaciones de Mejora",
      },
      table: {
        search: "Buscar...",
        age: "Edad",
        familyAge: "Edad de la Familia",
        income: "Ingresos",
        expense: "Gastos",
        savings: "Ahorro",
        assets: "Saldo Restante de Activos",
        lifeEvents: "Eventos de Vida",
        ageValue: "{age} Año",
        spouse: "Cónyuge: {age} Año",
        children: "Hijo",
        amount: "Millones de Yen",
        noData: "No hay datos",
      },
      timeline: {
        age: "Edad",
        event: "Evento",
        retirement: "Retiro",
        ageValue: "{age} Año",
        agePoint: "{age} Año",
        spouse: "Cónyuge: {age} Año",
        children: "Hijo",
        neededAmount: "Monto Requerido: {amount}",
        assets: "Activos: {amount}",
        education: "{childName} de {fundName}",
        child: "Hijo",
        educationFund: "Fondos Educativos"
      },
      summary: {
        title: "Resumen",
        monthlyIncome: "Ingreso Mensual",
        monthlyExpense: "Gasto Mensual",
        monthlyInvestment: "Monto de Inversión Mensual",
        monthlySavings: "Monto de Ahorro Mensual",
        totalAssets: "Patrimonio Neto Total",
        totalLiabilities: "Total de Pasivos",
        netWorth: "Patrimonio Neto",
        finalAssets: "Patrimonio Neto Final",
        peakAssets: "Activos al Pico",
        retirementAssets: "Activos al Retirarse",
        savingsRate: "Tasa de Ahorro",
        savingsRateDesc: "Proporción de Ahorro con Respecto a los Ingresos",
        retirementBalance: "Balance de Retiro",
        balance: "Balance",
        riskAssessment: "Evaluación de Riesgo",
        riskLow: "Bajo Riesgo",
        riskMedium: "Medio Riesgo",
        riskHigh: "Alto Riesgo",
        negativeAssets: "Existe una posibilidad de que los activos sean negativos en el futuro.",
        positiveAssets: "Se espera que los activos se mantengan positivos.",
        needImprovement: "Se necesita mejorar los ingresos y gastos.",
        unit: "Millones de Yen",
        atAge: "{age} Año",
      },
      chart: {
        title: "Vista Previa de Cambio de Activos",
        noData: "Ingrese datos para continuar",
        assets: "Activos",
        income: "Ingresos",
        expense: "Gastos",
      },
    },
    confirmation: {
      title: "Confirmación"
    },
    validation: {
      error: "Hay un error en la entrada."
    },
  },
  login: "Iniciar sesión",
  register: "Registrarse",
  loginDescription: "¿No tiene una cuenta? Por favor, regístrese.",
  registerDescription: "Cree una cuenta para comenzar su simulación de plan de vida.",
  email: "Correo electrónico",
  password: "Contraseña",
  passwordRequirements: "La contraseña debe tener al menos 8 caracteres e incluir letras y números.",
  loggingIn: "Iniciando sesión...",
  registering: "Registrando...",
  loginFailed: "Error al iniciar sesión.",
  registrationSuccess: "Registro completado.",
  registrationFailed: "Error en el registro.",
  myPage: "Mi Cuenta",
  logout: "Cerrar sesión",
  userProfile: "Perfil de Usuario",
  userProfileDescription: "Administrar la información de su perfil",
  savedSimulations: "Simulaciones Guardadas",
  savedSimulationsDescription: "Lista de sus resultados de simulación guardados",
  settings: "Configuración",
  accountSettings: "Configuración de la cuenta",
  accountSettingsDescription: "Administrar la configuración de su cuenta",
  changePassword: "Cambiar contraseña",
  changePasswordDescription: "Cambiar su contraseña",
} as Translation; 